var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTyperight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.553 19.248 14.8 12 7.553 4.752a.498.498 0 0 1 0-.707.5.5 0 0 1 .707 0l7.601 7.601a.5.5 0 0 1 0 .708L8.26 19.955a.5.5 0 1 1-.707-.707Z",
  fill: "currentColor"
})));
export { SvgTyperight as ReactComponent };
export default __webpack_public_path__ + "0156ec5b191a565fc8f04432c2661dae.svg";